import ReviewSubmittalsContainer from "./ReviewSubmittalsContainer";
export default ReviewSubmittalsContainer;
